import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './DeliveryOnlyHeader.sass';
import LocationInputBox from '../../LocationInputBox';
import Track from '../../../analytics/Track';
import ToastModal from '../../ToastModal';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import find from 'lodash/find';
import isNil from 'lodash/isNil';
import classnames from 'classnames';
import headerLogo from '../assets/logo-tagline.png';
import mapPin from '../assets/map-pin.svg'
import ArrowForward from '../../Icons/ArrowForward';

const ViewMenuButton = ({
  deliveryAddress,
  kitchenUrl,
  inRange,
  onClick,
  label
}) => (
  <span style={{display: 'inline-block', verticalAlign: 'middle'}}>
    { inRange ?
      <Track>
        <a
          id='location-search-button'
          data-address-type={deliveryAddress.type}
          href={kitchenUrl}
          className='search-location active'>
          { label }
          <ArrowForward color="#fff" strokeWidth={2}/>
        </a>
      </Track> :
      <Track>
        <button
          id='location-search-button-inactive'
          className='search-location inactive'
          {...{onClick}}>
          { label }
          <ArrowForward color="#fff" strokeWidth={2}/>
        </button>
      </Track>
    }
  </span>
);

class DeliveryOnlyHeader extends Component {
  constructor() {
    super()
    this.state = {
      showLocationModal: false
    };
  }

  render() {
    const {
      kitchenUrl,
      inRange,
      onAddressChange,
      savedAddresses,
      deliveryAddress,
      lessThan,
    } = this.props;

    const { showLocationModal } = this.state;

    const matchedSavedAddress = find(savedAddresses, (savedAddr) => {
      const sameLoc = isEqual(
          get(deliveryAddress, 'location'),
          get(savedAddr, 'delivery_address.location')
      );
      const sameAddr = isEqual(
          get(deliveryAddress, 'placeId'),
          get(savedAddr, 'delivery_address.address')
      );
      return sameLoc || sameAddr;
    });

    const locClassName = classnames('location-search', {
      'location-search-in-range': inRange,
      'location-search-saved-address': !isNil(matchedSavedAddress)
  })

    return (
      <div className='delivery-only-wrapper'>
        <ToastModal isOpen={showLocationModal} message="Please enter a valid address to see the menu"/>
        <header className='delivery-only-variant'>

            <div class="logo">
                <img src={headerLogo} alt="ClusterTruck" />
            </div>

            <div className='location-search-wrapper'>
              <h2>
                <span class="title">America’s First <br/></span>
                <span class="subtitle">Delivery Only<br/></span>
                <span style={{paddingLeft: "25%"}}class="title">Kitchen</span>
              </h2>

              <div className='homepage-location-selector'>
                <p class="loction-label">Where you at?</p>
                <div className='location-search-flex-container'>
                  <div className={locClassName}>
                      <LocationInputBox
                        placeholder="Street address, city, state"
                        {...{
                          onAddressChange,
                          deliveryAddress,
                          baseClass: "homePage"
                        }} />
                      <img alt="map location pin" class="location-icon" src={mapPin} />
                  </div>
                  <ViewMenuButton
                    {...{deliveryAddress, kitchenUrl, inRange}}
                    label={lessThan.small ? '' : 'View menu'}
                    onClick={() => {
                      this.setState({ showLocationModal: true });
                      this.timeout = setTimeout(() => { this.setState({ showLocationModal: false }) }, 2500);
                    }} />
                </div>
                <div
                  className="not-ordering">
                  Enter your location to get started!
                </div>
              </div>
            </div>

        </header>
      </div>
    );
  }
}

DeliveryOnlyHeader.propTypes = {
  kitchenUrl: PropTypes.string,
  inRange: PropTypes.bool,
  onToggleDeliveryModal: PropTypes.func.isRequired,
  onAddressChange: PropTypes.func.isRequired,
  savedAddresses: PropTypes.object,
  deliveryAddress: PropTypes.object,
  lessThan: PropTypes.object,
};

export default DeliveryOnlyHeader;
